import { createSlice, createEntityAdapter } from '@reduxjs/toolkit';

export const settingsAdapter = createEntityAdapter();

const INITIAL_STATE = {
    showMapCircles: false,
    measureDistance: false,
    showMapScaleBar: true,
    mapClusters: false,
    showMarkerLabels: false,
    markerLabel: {
        hunter: false,
        tag: false,
        dog: true,
    },
    showPhoneDirection: true,
    showCompassHeading: false,
    restartListeningToCompassInMap: false,
    hasCompassF: false,
    showCompass: true,
    compassValue: 0,
    shouldCompassTrack: true,
    keepScreenAlive: false,
    keyboardIsVisible: false,
    myPositionPulseEffect: false,
    flashLight: false,
    vibration: false,
    sound: false,
    shakeEnabled: false,
    shakeThreshold: 1.8,
    notificationEmail: null,
    language: 'en',
    isAblyConnected: false,
    socketsConnected: false,
    hasNetworkConnection: null,
    isRealtime: true,
    debugMode: false,
    isDebugModalVisible: false,
    lastUpdates: {
        devices: '',
        geofences: '',
        deviceTrails: '',
        hunterTrails: '',
        barkingTrails: '',
    },
    markersSize: {
        tag: 50,
        device: 50,
        hunter: 50,
    },
    trailsHeight: {
        user: 3,
        device: 3,
        hunter: 3,
    },
    wasPresenceChecked: false,
    nextAppState: false,
    shouldAblyReconnect: false,
    netWorkErrorTimes: 0,
    netWorkErrorVisible: false,
    deviceUniqueId: '',
};

const settingsReducer = createSlice({
    name: 'settings',
    initialState: settingsAdapter.getInitialState(INITIAL_STATE),
    reducers: {
        setSocketsConnected(state, action) {
            state.socketsConnected = action.payload;
        },
        reconnectAbly(state, action) {
            state.shouldAblyReconnect = action.payload;
        },
        setSetDeviceUniqueId(state, action) {
            state.deviceUniqueId = action.payload;
        },
        toggleDebugMode(state, action) {
            state.debugMode = action.payload;
        },
        setNotificationEmail(state, action) {
            state.notificationEmail = action.payload;
        },
        updateMarkersLabels(state, action) {
            state.markerLabel = { ...state.markerLabel, [action.payload.type]: action.payload.value };
        },
        setTrailsHeight(state, action) {
            state.trailsHeight = { ...state.trailsHeight, [action.payload.type]: action.payload.value };
        },
        setMarkersSize(state, action) {
            state.markersSize = { ...state.markersSize, [action.payload.type]: action.payload.value };
        },
    },
});

export const {
    setSocketsConnected,
    setTrailsHeight,
    updateMarkersLabels,
    toggleDebugMode,
    reconnectAbly,
    setSetDeviceUniqueId,
    setMarkersSize,
    setNotificationEmail,
} = settingsReducer.actions;

export default settingsReducer.reducer;
